(function () {
  if (window.GSCareGuide) return;

  var STORAGE_KEY = 'gs-care-guide';
  var CHECK_KEY = 'gs-material-check';

  function read(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function checkResult() {
    try {
      var saved = JSON.parse(read(CHECK_KEY) || 'null');
      return saved && saved.match ? saved.match : null;
    } catch (e) {
      return null;
    }
  }

  function urlParam() {
    try {
      return new URLSearchParams(window.location.search).get('material');
    } catch (e) {
      return null;
    }
  }

  function announce(match) {
    window.GSMaterialMatch = match;
    document.querySelectorAll('[data-gs-match-key]').forEach(function (el) {
      el.classList.toggle('is-match', !!match && el.getAttribute('data-gs-match-key') === match.key);
    });
    document.querySelectorAll('[data-gs-match-cta]').forEach(function (el) {
      if (!el.hasAttribute('data-default-text')) {
        el.setAttribute('data-default-text', el.textContent);
        el.setAttribute('data-default-href', el.getAttribute('href') || '#');
      }
      if (match) {
        el.textContent = (el.getAttribute('data-gs-match-cta') || '[material]').replace('[material]', match.name);
        if (match.url) el.setAttribute('href', match.url);
      }
    });
    document.dispatchEvent(new CustomEvent('gs:material-match', { detail: match }));
  }

  function CareGuide(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gs-cg-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-gs-cg-panel]'));
    if (!this.panels.length) return;
    this.bind();
    var design = window.Shopify && window.Shopify.designMode;
    var start = design ? null : urlParam() || read(STORAGE_KEY) || checkResult();
    this.show(this.has(start) ? start : this.panels[0].getAttribute('data-gs-cg-panel'), false);
  }

  CareGuide.prototype.has = function (key) {
    return !!key && this.panels.some(function (p) {
      return p.getAttribute('data-gs-cg-panel') === key;
    });
  };

  CareGuide.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-gs-cg-tab]');
      if (tab) return self.show(tab.getAttribute('data-gs-cg-tab'), true);
      var play = event.target.closest('[data-gs-cg-play]');
      if (play) return self.playVideo(play.closest('[data-gs-cg-video]'));
      var close = event.target.closest('[data-gs-cg-close]');
      if (close) return self.stopVideo(close.closest('[data-gs-cg-video]'));
    });
    this.root.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-gs-cg-tab]');
      if (!tab) return;
      var i = self.tabs.indexOf(tab);
      var next = null;
      if (event.key === 'ArrowRight') next = self.tabs[(i + 1) % self.tabs.length];
      else if (event.key === 'ArrowLeft') next = self.tabs[(i - 1 + self.tabs.length) % self.tabs.length];
      else if (event.key === 'Home') next = self.tabs[0];
      else if (event.key === 'End') next = self.tabs[self.tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      self.show(next.getAttribute('data-gs-cg-tab'), true);
      next.focus();
    });
  };

  CareGuide.prototype.show = function (key, remember) {
    var active = null;
    this.panels.forEach(
      function (panel) {
        var on = panel.getAttribute('data-gs-cg-panel') === key;
        if (!on) panel.querySelectorAll('[data-gs-cg-video].is-playing').forEach(this.stopVideo.bind(this));
        panel.hidden = !on;
        if (on) active = panel;
      }.bind(this)
    );
    this.tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-gs-cg-tab') === key;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    if (!active) return;
    if (remember) write(STORAGE_KEY, key);
    announce({ key: key, name: active.getAttribute('data-name'), url: active.getAttribute('data-url') });
  };

  CareGuide.prototype.playVideo = function (wrap) {
    if (!wrap) return;
    var template = wrap.querySelector('[data-gs-cg-video-template]');
    var thumb = wrap.querySelector('[data-gs-cg-play]');
    var close = wrap.querySelector('[data-gs-cg-close]');
    var video = template && template.content.querySelector('video');
    if (!video) return;
    var clone = video.cloneNode(true);
    clone.setAttribute('playsinline', '');
    wrap.insertBefore(clone, close);
    wrap.classList.add('is-playing');
    if (thumb) thumb.hidden = true;
    if (close) close.hidden = false;
    var attempt = clone.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
    clone.focus({ preventScroll: true });
  };

  CareGuide.prototype.stopVideo = function (wrap) {
    if (!wrap) return;
    wrap.querySelectorAll('video').forEach(function (v) {
      if (v.closest('template')) return;
      v.pause();
      v.remove();
    });
    wrap.classList.remove('is-playing');
    var thumb = wrap.querySelector('[data-gs-cg-play]');
    var close = wrap.querySelector('[data-gs-cg-close]');
    if (thumb) thumb.hidden = false;
    if (close) close.hidden = true;
  };

  var instances = new Map();

  function init(scope) {
    (scope || document).querySelectorAll('[data-gs-care-guide]').forEach(function (root) {
      if (!instances.has(root)) instances.set(root, new CareGuide(root));
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-gs-care-guide]').forEach(function (root) {
      instances.delete(root);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-gs-care-guide]');
    var instance = root && instances.get(root);
    var key = event.target.getAttribute('data-gs-cg-panel');
    if (instance && key) instance.show(key, false);
  });

  window.GSCareGuide = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
